export type QuoteBookingState =
  | "AVAILABLE"
  | "CONFIRMED"
  | "PAYMENT_REVIEW"
  | "CONSUMED";

export type QuoteBookingLocalOutcome = {
  quotePublicId: string;
  bookingState: Extract<QuoteBookingState, "CONFIRMED" | "PAYMENT_REVIEW">;
};

export function resolveQuoteBookingState(
  initialBookingState: QuoteBookingState,
  quotePublicId: string,
  localOutcome: QuoteBookingLocalOutcome | null,
): QuoteBookingState {
  return localOutcome?.quotePublicId === quotePublicId
    ? localOutcome.bookingState
    : initialBookingState;
}

export function createQuoteOutcomeCallbacks(
  quotePublicId: string,
  setLocalOutcome: (outcome: QuoteBookingLocalOutcome) => void,
) {
  return {
    onBookingComplete: () =>
      setLocalOutcome({ quotePublicId, bookingState: "CONFIRMED" }),
    onPaymentPending: () =>
      setLocalOutcome({ quotePublicId, bookingState: "PAYMENT_REVIEW" }),
  };
}
